import {
  readHeadersSessionEntriesForAccounts,
  readInboxHeadersSessionCache,
} from "@/lib/cache/inboxHeadersSessionCache";
import {
  getFolderSnapshot,
  isFolderSnapshotWarm,
  publishFolderSnapshot,
} from "@/lib/mail/inboxFolderBus";
import { filterTombstonedMessages } from "@/lib/mail/mailMutationHold";

/** Peint le bus depuis localStorage (stale-while-revalidate) si pas déjà chaud. */
export function hydrateInboxHeadersFromSession(
  accountId: number,
  folder = "INBOX"
): boolean {
  if (isFolderSnapshotWarm(getFolderSnapshot(accountId, folder))) {
    return false;
  }

  const entry = readInboxHeadersSessionCache(accountId, folder);
  if (!entry) return false;

  const messages = filterTombstonedMessages(accountId, folder, entry.messages);

  publishFolderSnapshot({
    accountId,
    folder: entry.folder,
    messages,
    total: Math.max(0, entry.total - (entry.messages.length - messages.length)),
    offset: entry.offset,
    fromCache: true,
    bootstrapped: true,
  });
  return true;
}

export function hydrateAllAccountsInboxFromSession(accountIds: number[]): number {
  let count = 0;
  for (const entry of readHeadersSessionEntriesForAccounts(accountIds)) {
    if (hydrateInboxHeadersFromSession(entry.accountId, entry.folder)) {
      count += 1;
    }
  }
  return count;
}
